import { schema } from "@moment/api-collab/prosemirror-schema";

import { truncate } from "~/utils/format/string";

export const DESCRIPTION_MAX_LENGTH = 150; // Google truncates snippets to 155-160 chars. We'll use 150 to be safe. See: https://moz.com/blog/how-long-should-your-meta-description-be-2018.

export const getTruncatedDescriptionFromCell = (doc: unknown) => {
	return truncate(schema.nodeFromJSON(doc).textContent, DESCRIPTION_MAX_LENGTH);
};

export const formatTitle = (title: string | (string | undefined)[]) => {
	return Array.isArray(title) ? title.filter(Boolean).join(" / ") : title;
};
